import React, { useState } from "react";
import { Card, CardHeader, CardBody, Table, Collapse } from "reactstrap";

const JobPairsSummary = ({ jobPairs }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card>
      <CardHeader onClick={() => setIsOpen(!isOpen)} style={{ cursor: "pointer" }}>
        <h6 className="mb-0">
          {isOpen ? "▼" : "▶"} Total jobs selected: {jobPairs.length}
        </h6>
      </CardHeader>
      <Collapse isOpen={isOpen}>
        <CardBody>
          <Table size="sm" bordered>
            <thead>
              <tr>
                <th>Condition 1</th>
                <th>Condition 2</th>
              </tr>
            </thead>
            <tbody>
              {jobPairs.length > 0 ? (
                jobPairs.map((pair, idx) => (
                  <tr key={idx}>
                    <td>{pair.cond1}</td>
                    <td>{pair.cond2}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="text-center text-muted">
                    No valid pairs selected
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardBody>
      </Collapse>
    </Card>
  );
};

export default JobPairsSummary;